import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyHistoryStatus = createAsyncThunk('/dashboard_detail_company_history_status/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyClientStatusDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyHistoryStatusSlice = createSlice({
    name: 'dashboard_detail_company_history_status',
    initialState: {
        isLoading: false,
        dashboard_detail_company_history_status: []
    },

    /*extraReducers: {
        [getDetailCompanyHistoryStatus.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyHistoryStatus.fulfilled]: (state, action) => {
            state.dashboard_detail_company_history_status = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyHistoryStatus.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyHistoryStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyHistoryStatus.fulfilled, (state, action) => {
                state.dashboard_detail_company_history_status = action.payload.data;
                state.isLoading = false;
            }   )
            .addCase(getDetailCompanyHistoryStatus.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export default dashboardDetailCompanyHistoryStatusSlice.reducer